module.exports = "/assets/data/9037cd3d2d3b8470e6e0a3e70eccb415-HG2.data.json";